import { createSelector } from '@reduxjs/toolkit'
import { buildFlightDateChangeCartEvaluationItems } from 'businessTraveller/utils/buildFlightDateChangeCartEvaluationItems'
import { selectIsFlightChangeDateTripRequestEnabled } from 'businessTraveller/selectors/selectIsFlightChangeDateTripRequestEnabled'
import { selectIsLebtItemPoliciesEnabled } from 'businessTraveller/selectors/itemPolicy/selectIsLebtItemPoliciesEnabled'
import { getOccupantsFromExistingOrder } from 'checkout/selectors/request/insurance'
import { getFlightItemsView } from 'checkout/selectors/view/flights'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import type { CartEvaluationItemInputWire } from 'businessTraveller/api/requestPostCartEvaluation'

// The flight date change checkout evaluates the whole cart as the one date change line.
export const selectIsFlightDateChangeCartEvaluation = createSelector(
  (state: App.State) => selectIsLebtItemPoliciesEnabled(state),
  (state: App.State) => selectIsFlightChangeDateTripRequestEnabled(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (isItemPoliciesEnabled, isFlagEnabled, postPurchase): boolean =>
    isItemPoliciesEnabled && isFlagEnabled && postPurchase === 'flight-change-dates',
)

export const getFlightDateChangeCartEvaluationItems = createSelector(
  (state: App.State) => state.geo.currentCurrency,
  (state: App.State) => state.businessTraveller.currentBusinessAccount?.employee?.id,
  (state: App.State) => getOccupantsFromExistingOrder(state),
  (state: App.State) => getFlightItemsView(state),
  (
    currencyCode,
    employeeId,
    existingOrderOccupants,
    flightItemsViews,
  ): App.WithDataStatus<Array<CartEvaluationItemInputWire>> => {
    const travellerCount = existingOrderOccupants
      ? existingOrderOccupants.adults +
      (existingOrderOccupants.children ?? 0) +
      (existingOrderOccupants.infants ?? 0)
      : 1

    return {
      hasRequiredData: flightItemsViews.hasRequiredData,
      data: buildFlightDateChangeCartEvaluationItems({
        flightItemsViews,
        currencyCode,
        employeeId,
        travellerCount,
      }),
    }
  },
)
